<template>
  <section :class="$style.questionsContainer">
    <Wrapper :class="$style.inner">
      <h2 :class="$style.title">{{ title }}</h2>
      <div :class="$style.list">
        <ArticleThumbnail
          v-for="(article, articleIndex) in articles"
          :key="articleIndex"
          :class="$style.article"
          :article="article"
          is-horizontal
        />
      </div>
    </Wrapper>
  </section>
</template>

<script>
import ArticleThumbnail from '~/components/ArticleThumbnail'

export default {
  name: 'OtherArticles',

  components: {
    ArticleThumbnail,
  },

  props: {
    articles: {
      type: Array,
      required: true,
    },
  },

  computed: {
    title() {
      if (this.$i18n.locale === 'fr') return 'Articles liés'
      return 'Linked articles'
    },
  },
}
</script>

<style lang="scss" module>
.questionsContainer {
  position: relative;

  margin-top: 64px;
}

.inner {
  padding: 40px 24px 80px;

  @include above(medium) {
    padding: 80px 24px 128px;
  }
}

.title {
  @include typo-large-title;

  max-width: 700px;
  margin: 0 auto;

  @include above(small) {
    text-align: center;
  }
}

.list {
  display: grid;
  gap: 40px;
  margin-top: 56px;

  @include above(small) {
    grid-template-columns: repeat(2, 1fr);
  }
}

.article {
  max-width: none;
  @include below(large) {
    & > div {
      flex-direction: column !important;
      align-items: flex-start !important;
    }
  }
}
</style>
